import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

const COLORS = ["#0072A7", "#57B5E1", "#80d9ff"]

export default function Chart(props){
  return(
    <ResponsiveContainer width={'100%'} aspect={3}>
      <BarChart 
        data={props.data}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Bar dataKey={ props.dataKey ? props.dataKey : "number"} fill={"#0072A7"} />
      </BarChart>
    </ResponsiveContainer>
  )
}